import { render, staticRenderFns } from "./IssueSolveTime.vue?vue&type=template&id=1ea69a98&scoped=true"
import script from "./IssueSolveTime.vue?vue&type=script&lang=js"
export * from "./IssueSolveTime.vue?vue&type=script&lang=js"
import style0 from "./IssueSolveTime.vue?vue&type=style&index=0&id=1ea69a98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea69a98",
  null
  
)

export default component.exports